function init() {
	let i;
	let imgDefer = document.getElementsByClassName('defer-image');
	for (i = 0; i<imgDefer.length; i++) {
		if(imgDefer[i].getAttribute('data-src')) {
			imgDefer[i].setAttribute('src',imgDefer[i].getAttribute('data-src'));
			imgDefer[i].onload = function() {
				this.removeAttribute('data-src');
			};
		}
	}

	imgDefer = document.getElementsByClassName('defer-bg-image');
	for (i = 0; i<imgDefer.length; i++) {
		if(imgDefer[i].getAttribute('data-src')) {
			const bg_image_path = imgDefer[i].getAttribute('data-src');
			imgDefer[i].setAttribute('style', 'background-image: url('+bg_image_path + ')');
		}
	}
}
window.onload = init;
